import React from 'react';

import Characteristics from '@r1-frontend/ui-react/components/List/Characteristics';
import { TCharacteristicsProps } from '@r1-frontend/ui-react/components/List/Characteristics/Characteristics';
import ControlElement from '@r1-frontend/ui-react/components/typography/controlElement';
import { FullWidthListContainer } from '@r1-frontend/ui-react/experimental/containers';
import { usePartialList } from '@r1-frontend/shared/hooks/usePartialList';

interface IProps {
    characteristics: TCharacteristicsProps[],
    rowCount?: number,
}

const EquipmentCharacteristics = ({
    characteristics = [],
    rowCount = 3,
} : IProps): JSX.Element | null => {
    const [partialCharacteristics, isPartial, setIsPartial] = usePartialList(characteristics, rowCount);

    if (!characteristics.length) {
        return null;
    }

    return (
        <FullWidthListContainer $direction='column' $desktop={8} $mobile={8}>
            {partialCharacteristics.map((item) => {
                return (
                    <Characteristics
                        key={item.title}
                        title={item.title}
                        value={item.value}
                    />
                );
            })}

            {(characteristics.length > rowCount) &&
                <ControlElement
                    type={'large'}
                    onClick={() => setIsPartial(!isPartial)}
                >
                    {isPartial ? 'Показать больше' : 'Скрыть'}
                </ControlElement>
            }
        </FullWidthListContainer>
    );
};

export default React.memo(EquipmentCharacteristics);
